export default "__VITE_ASSET__Dbuiyipg__"